<template>
		<v-card outlined 
			style="
				width:100%; 
				height:100%; 
				object-fit: fill;   
				border-color: grey " 
		>
			<v-system-bar 
				lights-out dark 
				class="vue-draggable-handle"
			>		
				<span 
					:class="$vuetify.theme.dark ? 'white--text' : 'black--text'"
				> 
					{{ $ml.get('safe_zone') }} 
				</span>
			    <v-spacer></v-spacer>
			     
			   
			     <v-tooltip top>
					<template v-slot:activator="{ on }">
						<v-icon 
							x-small
							:color="color_message"
							v-on="on"
						>mdi-circle</v-icon>
					</template>
					<span>{{ status_message }}</span>
			     	<br>
			     	<span>{{ $ml.get('events_received') }}: {{ num_events }}</span>
				</v-tooltip>			     
			     <v-btn x-small outlined icon color="error"
				    @click="$emit('close_component', layout_id)"
				    v-if="currentUser && currentUser.user.roleId < 3 "
				>
					<v-icon x-small color="error" class="ml-1" outlined>mdi-close</v-icon>
				</v-btn> 
			</v-system-bar>						
			<v-card-text 
				class="no-drag" 
				style="
					width:100%; 
					height:100%; 
					object-fit: fill;" 
				ref="card"
			>
				<v-data-table
					dense
				    :headers="headers"
				 	:items="list"
				    class="elevation-5"			    
				    :hide-default-footer="height < 56 ?  true : false"
				   	:options.sync="options"
				   	:server-items-length="total"
				   	:footer-props="{
				   		showFirstLastPage: true,
				   		itemsPerPageOptions: [15, 30],
				   		showCurrentPage: true
				   	}"				   	
				    :height="height+'px'"
				    fixed-header
				    item-key="index"
				>
					<template v-slot:item.full_photo_path="{ item }">
						
						<div class="pa-0 ma-0"  @click="send(item)" >							 
				    		<!-- max-width="80px;" -->
							<v-img 
								:src="`${$protocol}${$localhost}:${$port}/${item.full_photo_url}`"  
								height="25px" 
								style="width:80px"										
								
							/>
								<!-- contain -->
							<!-- 'http://'+${$localhost}+':'+this.$port+''+ -->
							<!-- width="100%" 
								style="background-size: 80%; object-fit: fill;"  
								class="pa-0 ma-0" -->
						</div>	
					</template>
				</v-data-table>
			</v-card-text>
			<show_data
				v-if="info_to_modal"
				:info_to_show="info_to_modal"	
				is_from="events"			
				@close="info_to_modal=$event"
			></show_data>
		</v-card>
	
</template>
<script>
import axios from 'axios'
import show_data from '@/components/gun/show_data.vue'
import io from 'socket.io-client'
import EventBus from '@/event-bus';
	export default{
		name: 'component_safe_zone',
		components: {
			show_data
		},
		props: ['host_from', 'layout'],
		data: vm => ({
			headers:[
				// { text: vm.$ml.get('id'), value: 'id', align: 'center' },
				{ text: vm.$ml.get('hostname'), value: 'host.name', align: '' },
				{ text: vm.$ml.get('category'), value: 'category', align: '' },
				{ text: vm.$ml.get('segment'), value: 'full_photo_path', align: '' },
				{ text: vm.$ml.get('date'), value: 'timestamp', align: '' },

				],
			height: 400,
			options: { itemsPerPage:30 },
			total: 1,
			list: [],
			status_message: '',
			color_message: '',
			socket: null,
			info_to_modal: null,
			num_events: 0,
		}), // data
		
		created(){

		}, // created

		watch:{
			options: {
				handler(){
					this.get_list();
				}, deep: true,
			},// options
			layout: function(v){
				console.log(v, 'layout')
				if (v) {
					this.onResize(v);
				}
			}, // layout
		}, // watch
		methods:{
			get_list(){
				const { page, itemsPerPage } = this.options;
				let pg=1, sw=0;
				if (itemsPerPage==15) {
					if (page % 2 == 0) {
						pg=(page/2);
						sw=2;
					}else{
						pg=parseInt(page/2)+1;
						sw=1;
					}
				}else{
					pg=page
				}
				let api = this.$URL + '/api/v1/alertgun/?page='+pg;
				axios.defaults.withCredentials=true;
				axios.get(api).then( res => {
					let item =res.data;
					let items=item.rows;
					this.total=parseInt(item.count);
						

						if (itemsPerPage<=15) {
							if (sw==1) {
								items=items.slice((sw - 1) * itemsPerPage, sw  + itemsPerPage );
							}else if (sw==2) {
								items=items.slice(16, 30 );
							}

						}
						let new_list=[];
						if ( items &&  this.host_from) {
							for (var i = 0; i < items.length; i++) {
								if (items[i].host && items[i].host.name && items[i].host.name==this.host_from){
									new_list.push(items[i]);
								}
							}
						}else{
							new_list=items;
						}
						this.list=new_list;
						console.log(new_list, 'info rows api alertgun');
						// let list_new=[];
						
						/*for(let j of items){
							if (this.render_hostname(j)) {

								list_new.push(this.info_format(j));
							}
						}*/

				}).catch( er =>{
					console.log(er, 'error get list safe zone')
				})
			}, // get list
			send(item){
				this.info_to_modal=item;
				console.log(item, 'item to show sz');
			}, // send

			onResize(){
				console.log(this.$refs, 'resize')
				if (this.$refs.card) {
			 		this.height=this.$refs.card.clientHeight-130; 
			 		console.log(this.height, 'height events')
				}
			}, // onResize

		}, // methods

		computed:{
			list_render: function(){
				return this.list;
			}, // list render

			currentUser() {
		      return this.$store.state.auth.user;
		    }, // currentUSer
		
		}, // computed

		mounted(){
			let count=0;
			if (this.layout) {
				this.$nextTick( ()=>{
					this.onResize(this.layout);
				}) 
			}
			EventBus.$on('events_sz', (actions) =>{
				let to_list=actions;
				if (this.host_from) {
					if ( 	
						actions && 
						actions.host && 
						actions.host.name && 
						this.host_from!==actions.host.name) {		
						to_list=null;
					}
				}
				if (to_list) {					
					count++;
					this.list.unshift(to_list);
					this.num_events=count;
				}		
				
			})
			EventBus.$on('status_sz', (actions) =>{
				console.log(actions, 'status sz on');
				this.status_message=actions.status_msg;
				this.color_message=actions.color_msg;

			})
		}, // mounted
		
		
	};
</script>